export default {
      id: "instagram-usage",
      viewBox: "0 0 24.423 24.377",
      url: __webpack_public_path__ + "icons/mvm-icons.svg#instagram",
      toString: function () {
        return this.url;
      }
    }